import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
  ArrowDown,
  GlobeHemisphereWest,
  Money,
  Timer,
  Heartbeat,
  Lightning,
  Handshake,
} from 'phosphor-react';
import { Button } from '@material-ui/core';

import PageBase from '../../components/layout/PageBase';

import styles from '../../styles/sass/pages/Careers.module.scss';
import track from '../../lib/track';

export interface Props {
  teams: string[];
  categories: any[];
  locations: string[];
  dispatch: any;
}

export class CareersPage extends React.Component<Props, {}> {
  scrollToOpenings = () => {
    const element: HTMLElement | null = document.getElementById('sectionCTA');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  };

  sendEmail = () => {
    const win: any = window.open('mailTo:apply@toriihomes.com', '_blank');
    win.focus();
  };

  componentDidMount() {
    track.trackPage('Carrers');
  }

  render() {
    return (
      <PageBase disableOverflow>
        <div className="page-container row center-xs">
          <section className={styles.sectionHero}>
            <div className={styles.textBox}>
              <h1 className={styles.textPrimary}>join the team</h1>
              <span className={styles.textTertiary}>
                We’re looking for amazing people from all backgrounds to help us
                build the future of real estate and home ownership.
              </span>
            </div>
            <Button
              className={styles.heroButton}
              onClick={this.scrollToOpenings}
            >
              Apply below{' '}
              <ArrowDown
                size={24}
                color="#ffff"
                weight="bold"
                className={styles.arrowIcon}
              />
            </Button>
          </section>
          <section className={styles.sectionMission}>
            <div className={styles.textBox}>
              <h1 className={styles.textPrimary}>our mission</h1>
              <span className={styles.textTertiary}>
                Finding the right home is hard, and buying it is even harder.
                We’re <span className={styles.wordBreakTablet}>&nbsp;</span>
                reinventing the entire process while providing the best service
                and experience possible, turning a transactional business into a
                relationship that lasts for decades.
              </span>
            </div>
          </section>
          <section className={styles.sectionValues}>
            <h1 className={styles.textPrimary}>our values</h1>
            <div className={styles.valuesContainer}>
              <img src="/static/img/team.jpg" className={styles.teamImage} />
              <article className={styles.valuesBlocks}>
                <div className={styles.valuesBlock}>
                  <h4 className={styles.textSecondary}>Trust</h4>
                  <span className={styles.textTertiary}>
                    We’re open, honest, and transparent. We take accountability
                    and always seek to do right by one another.
                  </span>
                </div>
                <div className={styles.valuesBlock}>
                  <h4 className={styles.textSecondary}>Respect</h4>
                  <span className={styles.textTertiary}>
                    We’re thoughtful, humble, and kind. We nurture and value
                    different perspectives to make better decisions.
                  </span>
                </div>
                <div className={styles.valuesBlock}>
                  <h4 className={styles.textSecondary}>Experience</h4>
                  <span className={styles.textTertiary}>
                    We provide the best customer service imaginable and strive
                    to delight our customers and our team at every opportunity.
                  </span>
                </div>
                <div className={styles.valuesBlock}>
                  <h4 className={styles.textSecondary}>Innovation</h4>
                  <span className={styles.textTertiary}>
                    We create something new every single day. We’re naturally
                    curious and constantly iterating.
                  </span>
                </div>
                <div className={styles.valuesBlock}>
                  <h4 className={styles.textSecondary}>Collaboration</h4>
                  <span className={styles.textTertiary}>
                    We are not lone wolves… we work as a team to get s*** done.
                  </span>
                </div>
                <div className={styles.valuesBlock}>
                  <h4 className={styles.textSecondary}>Drive</h4>
                  <span className={styles.textTertiary}>
                    We work hard because changing the world is never easy. We’re
                    dedicated to the mutual success and growth of everyone we
                    encounter.
                  </span>
                </div>
              </article>
            </div>
          </section>
          <section className={styles.sectionBenefits}>
            <h1 className={styles.textPrimary}>Benefits & Perks</h1>
            <div className={styles.benefitsContainer}>
              <article className={styles.benefitsBlocks}>
                <GlobeHemisphereWest
                  size={32}
                  color="#463264"
                  weight="duotone"
                />
                <h4 className={styles.textSecondary}>Work Remotely</h4>
                <span className={styles.textTertiary}>
                  It’s a big world, live and work wherever you like
                </span>
              </article>
              <article className={styles.benefitsBlocks}>
                <Money size={32} color="#463264" weight="duotone" />
                <h4 className={styles.textSecondary}>Competitive Salary</h4>
                <span className={styles.textTertiary}>
                  Get paid what you deserve
                </span>
              </article>
              <article className={styles.benefitsBlocks}>
                <Timer size={32} color="#463264" weight="duotone" />
                <h4 className={styles.textSecondary}>Flexible Time Off</h4>
                <span className={styles.textTertiary}>
                  Take the time you need to be your best self
                </span>
              </article>
              <article className={styles.benefitsBlocks}>
                <Heartbeat size={32} color="#463264" weight="duotone" />
                <h4 className={styles.textSecondary}>Health & Retirement</h4>
                <span className={styles.textTertiary}>
                  Medical, dental, vision, life/disability insurance, and 401(k)
                  retirement plans for all our teammates
                </span>
              </article>
              <article className={styles.benefitsBlocks}>
                <Lightning size={32} color="#463264" weight="duotone" />
                <h4 className={styles.textSecondary}>Investment In You</h4>
                <span className={styles.textTertiary}>
                  In addition to a laptop and the basics, we'll help fund your
                  personal and professional development
                </span>
              </article>
              <article className={styles.benefitsBlocks}>
                <Handshake size={32} color="#463264" weight="duotone" />
                <h4 className={styles.textSecondary}>Stock Options</h4>
                <span className={styles.textTertiary}>
                  Every employee has the opportunity to become a shareholder and
                  be part of the company’s success
                </span>
              </article>
            </div>
          </section>
          <section className={styles.sectionFeedback}>
            <div className={styles.textBox}>
              <span className={styles.feedbackQuotes}>“</span>
              <span className={styles.feedbackContent}>
                I absolutely love working at Torii. It's rare that your
                teammates actually feel like a family and I'm lucky enough to
                have found that here. Everyone is supportive, everyone has a
                voice, and I honestly look forward to work every day.
              </span>
            </div>
            <div className={styles.feebackPerson}>
              <img
                src="/static/img/about/lauren.png"
                className={styles.feedbackPersonPicture}
              />
              <span className={styles.personTitle}>Lauren Locks</span>
              <span className={styles.personDesignation}>
                Director of Client Success
              </span>
            </div>
          </section>
          <section id="sectionCTA" className={styles.sectionCTA}>
            <div className={styles.textBox}>
              <h1 className={styles.textPrimary}>Apply</h1>
              <span className={styles.textTertiary}>
                We're always looking for great people to join the team. If
                you're interested in disrupting a trillion-dollar industry and
                revolutionizing one of the largest events in someone's life -
                let's talk. Apply below or email us at{' '}
                <a
                  href="mailTo:apply@toriihomes.com"
                  target="_blank"
                  style={{ color: 'white' }}
                >
                  <strong>apply@toriihomes.com</strong>
                </a>
              </span>
            </div>
            <Button
              className={styles.ctaButton}
              onClick={() => {
                this.sendEmail();
              }}
            >
              Apply Now
            </Button>
          </section>
        </div>
      </PageBase>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

const mapStateToProps = (state: any) => ({
  teams: state.careers.teams,
  locations: state.careers.locations,
  categories: state.careers.categories,
});

export default connect(mapStateToProps, mapDispatchToProps)(CareersPage);
